import {NEWS_IMG} from './types'
import {NEWS_IMG_CLOSE} from './types'




export function openpicture(src) {
    return function (dispatch) {
        dispatch({type: NEWS_IMG, payload: src})
    }
}
export function ClosePicture() {
    return function (dispatch) {
        dispatch({type: NEWS_IMG_CLOSE,})
    }
}